"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsWordpress = checkIsWordpress;
exports.requestData = requestData;
exports.proxyUrl = proxyUrl;
exports.getFeed = getFeed;
exports.getBlogData = getBlogData;
exports.getStoreData = getStoreData;
exports.parseFeed = parseFeed;
Object.defineProperty(exports, "capText", {
  enumerable: true,
  get: function get() {
    return _stringHelper.capText;
  }
});
exports.enums = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _stringHelper = require("./string-helper");

var _postMessageHelper = _interopRequireDefault(require("./post-message-helper"));

var _store = _interopRequireDefault(require("@eig-builder/core-utils/store"));

// import { getRuntimeConfig } from './runtime-config-helper'
var postMessageHelper;
/**
 * This function wraps the given url with the DataProxy. This is currently used to circumvent the CORS issues that arise with requesting a WordPress feed.
 * @param {*} url
 */

function proxyUrl(url) {
  // Temp solution to prevent cors issues when fetching RSS feed.
  return "https://data.mywebsitebuilder.com/dl?".concat(url);
}
/**
 * This function tries to retrieve and parse a text/xml document using the given feedUrl.
 * @param {*} feedUrl
 */


function getFeed(_x) {
  return _getFeed.apply(this, arguments);
}
/**
 * This function tries to parse a text/xml document to a json object. At the moment it assumes a WordPress blog rss feed.
 * @param {*} feed
 */


function _getFeed() {
  _getFeed = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(feedUrl) {
    var feed;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (checkIsWordpress()) {
              _context.next = 3;
              break;
            }

            throw new Error('Not running in WordPress context.');

          case 3:
            _context.next = 5;
            return window.fetch(proxyUrl(feedUrl), {
              credentials: 'omit'
            });

          case 5:
            feed = _context.sent;
            _context.next = 8;
            return feed.text();

          case 8:
            feed = _context.sent;
            _context.next = 11;
            return new window.DOMParser().parseFromString(feed, 'text/xml');

          case 11:
            feed = _context.sent;
            return _context.abrupt("return", feed);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            throw _context.t0;

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
  return _getFeed.apply(this, arguments);
}

function parseFeed(_x2) {
  return _parseFeed.apply(this, arguments);
}
/**
 * This function uses the postMessageHelper.createPostMessageAPITunnel to retrieve data and returns a Promise.
 * @param {*} path
 */


function _parseFeed() {
  _parseFeed = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(feed) {
    var items, posts;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            items = Array.from(feed.querySelectorAll('item'));
            posts = items.map(function (item, i) {
              var id = item.querySelector('post-id').innerHTML;
              var title = item.querySelector('title').innerHTML;
              var link = item.querySelector('link').innerHTML;
              var children = Array.from(item.childNodes);
              var index = children.findIndex(function (n) {
                return n.tagName === 'content:encoded';
              });
              var content = document.createElement('div');
              content.innerHTML = children[index].innerHTML.replace('<![CDATA[', '').replace(']]>', '');
              var leader = (0, _stringHelper.capText)(content.innerText, 325);
              var leader_image = content.querySelector('img').src; // eslint-disable-line

              var published_on = new Date(item.querySelector('pubDate').innerHTML); // eslint-disable-line

              return {
                id: id,
                title: title,
                leader: leader,
                published_on: published_on,
                leader_image: leader_image,
                link: link
              };
            });
            return _context2.abrupt("return", posts);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseFeed.apply(this, arguments);
}

function requestData(path) {
  return new Promise(function (resolve, reject) {
    if (!checkIsWordpress()) {
      return reject(new Error('Not running in WordPress context.'));
    }

    if (!postMessageHelper) {
      postMessageHelper = new _postMessageHelper["default"]();
    }

    postMessageHelper.createPostMessageAPITunnel(path, function (data) {
      return resolve(data);
    }, function (err) {
      return reject(err);
    }); // use arrow functions to prevent scope issues for when devs use requestData directly.
  });
}
/**
 * This method returns the blog data from a WordPress site if it is available.
 */


function getBlogData() {
  return _getBlogData.apply(this, arguments);
}
/**
 * This method returns the store data from a WordPress site if it is available.
 */


function _getBlogData() {
  _getBlogData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var data;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (checkIsWordpress()) {
              _context3.next = 3;
              break;
            }

            throw new Error('Not running in WordPress context.');

          case 3:
            _context3.next = 5;
            return requestData('/creativemail/v1/bloginfo');

          case 5:
            data = _context3.sent;

            if (!((0, _typeof2["default"])(data) !== 'object')) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return");

          case 8:
            return _context3.abrupt("return", data);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            throw _context3.t0;

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 11]]);
  }));
  return _getBlogData.apply(this, arguments);
}

function getStoreData() {
  return _getStoreData.apply(this, arguments);
}
/**
 * This function checks if the user is a wordpress user
 */


function _getStoreData() {
  _getStoreData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var data;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (checkIsWordpress()) {
              _context4.next = 3;
              break;
            }

            throw new Error('Not running in WordPress context.');

          case 3:
            _context4.next = 5;
            return requestData('/creativemail/v1/wc_products');

          case 5:
            data = _context4.sent;

            if (!((0, _typeof2["default"])(data) !== 'object')) {
              _context4.next = 8;
              break;
            }

            return _context4.abrupt("return");

          case 8:
            return _context4.abrupt("return", data);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);
            throw _context4.t0;

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 11]]);
  }));
  return _getStoreData.apply(this, arguments);
}

function checkIsWordpress() {
  if (window && window.shellRuntime) {
    var brand = window.shellRuntime.runtime._brand;

    if (brand === 'creativemail') {
      return true;
    }
  }

  if (window && window.authState) {
    var authState = window.authState.getValue();
    return authState && authState.accountType && authState.accountType.toLowerCase() === 'wordpress';
  }

  var state = (0, _store["default"])().getState();
  return state.auth && state.auth.accountType && state.auth.accountType.toLowerCase() === 'wordpress';
}

var enums = {
  BlogPosts: 0,
  BlogInformation: 1,
  Images: 2,
  Colors: 3,
  WooCommerceProducts: 4,
  AvailablePlugins: 5,
  Synchronize: 6,
  ActivatePlugins: 7
};
exports.enums = enums;